import { render, staticRenderFns } from "./TabsMsg.vue?vue&type=template&id=50150de2&scoped=true&"
import script from "./TabsMsg.vue?vue&type=script&lang=js&"
export * from "./TabsMsg.vue?vue&type=script&lang=js&"
import style0 from "./TabsMsg.vue?vue&type=style&index=0&id=50150de2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50150de2",
  null
  
)

export default component.exports